import {
  hideLoadingSpinner,
  showLoadingSpinner,
  swalAlertDanger,
} from "../components/common/Alerts";
import instanceAPI from "../api/axios.service";

export const getData = async (route, showAlert = true) => {
  try {
    const response = await instanceAPI.get(route);
    return response;
  } catch (error) {
    if (showAlert) {
      swalAlertDanger("Error al procesar la solicitud", "", () => {});
    }
    console.error(`API Error en ${route}:`, error);
    throw error; // Lanzar el error para que pueda ser manejado por el componente
  }
};

export const postData = async (route, data, showSpinner = false) => {
  try {
    if (showSpinner) showLoadingSpinner();
    const response = await instanceAPI.post(route, data);
    return response;
  } catch (error) {
    swalAlertDanger("Error al procesar la solicitud", "", () => {});
    throw error; // Re-lanzar para que el componente pueda manejar el error correctamente
  } finally {
    if (showSpinner) hideLoadingSpinner();
  }
};

export const putData = async (route, data, showSpinner = false) => {
  try {
    if (showSpinner) showLoadingSpinner();
    const response = await instanceAPI.put(route, data);
    return response;
  } catch (error) {
    swalAlertDanger("Error al procesar la solicitud", "", () => {});
    throw error;
  } finally {
    if (showSpinner) hideLoadingSpinner();
  }
};

export const deleteData = async (route, data = null, showSpinner = false) => {
  try {
    if (showSpinner) showLoadingSpinner();
    const response = await instanceAPI.delete(route, data ? { data } : {});
    return response;
  } catch (error) {
    swalAlertDanger("Error al procesar la solicitud", "", () => {});
    throw error;
  } finally {
    if (showSpinner) hideLoadingSpinner();
  }
};

export const patchData = async (route, data, showSpinner = false) => {
  try {
    if (showSpinner) showLoadingSpinner();
    const response = await instanceAPI.patch(route, data);
    return response;
  } catch (error) {
    swalAlertDanger("Error al procesar la solicitud", "", () => {});
    throw error;
  } finally {
    if (showSpinner) hideLoadingSpinner();
  }
};

export const getPromotions = async () => {
  try {
    const response = await instanceAPI.get("/api/admin/get_promotions");
    return response;
  } catch (error) {
    console.error("Error fetching promotions:", error);
    swalAlertDanger("Error al obtener promociones", "", () => {});
    throw error;
  }
};

export const getClientsBySeller = async (userId) => {
  try {
    const response = await instanceAPI.post("/api/admin/get_clients_by_seller", {
      user_id: userId
    });
    return response;
  } catch (error) {
    swalAlertDanger("Error al obtener clientes", "", () => {});
    throw error;
  }
};

export const getPromotionsForSku = async (sku) => {
  try {
    const response = await instanceAPI.get(`/api/admin/get_promotions_for_sku/${sku}`);
    return response;
  } catch (error) {
    console.error("Error al obtener promociones para SKU:", sku, error);
    throw error;
  }
};
